import React from "react";
import {TranslationDomainEnum} from "../../../types/enums";
import {Button} from "antd";
import {Translate} from "../../../components/util/translation.util";

type Props = {
    label: string,
    translationDomain: TranslationDomainEnum
}

export const SubmitType: React.FC<Props> = ({label, translationDomain}) => {
    return (
        <Button type="primary" htmlType={`submit`}>
            <Translate message={label ?? `global.button.submit`} domain={translationDomain ?? TranslationDomainEnum.MESSAGES} />
        </Button>
    )
}